import { useIsLoggedOn } from "./useIsLoggedOn";
import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";

export const useDealerTireSizeSetting = (): boolean => {
  const dealer = useNullableDealerAccountInfo();
  const isLoggedOn = useIsLoggedOn();

  switch (dealer?.dealerEnableAdvancedSearchTiresize) {
    case "SHOW":
      return true;
    case "AUTH":
      return isLoggedOn;
    default:
      return false;
  }
};
